import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video"]

  connect() {
    this.setupVideos()
    this.setupIntersectionObserver()
    this.setupHoverEffects()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupVideos() {
    this.videoTargets.forEach(video => {
      // Configuration initiale
      video.style.transition = 'filter 0.4s ease, transform 0.3s ease'

      // S'assurer que les vidéos sont muettes et en boucle
      video.muted = true
      video.loop = true
      video.volume = 0

      // Forcer l'autoplay
      video.play().catch(() => {})
    })
  }

  setupIntersectionObserver() {
    // Observer pour démarrer/arrêter les vidéos selon la visibilité
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Vidéos visibles - démarrer
          this.videoTargets.forEach(video => {
            video.play().catch(() => {})
          })
        } else {
          // Vidéos hors viewport - pause
          this.videoTargets.forEach(video => {
            video.pause()
          })
        }
      })
    }, { threshold: 0.3 })

    // Observer le conteneur
    this.observer.observe(this.element)
  }

  setupHoverEffects() {
    // Effet hover sur chaque vidéo
    this.videoTargets.forEach((video, index) => {
      const container = video.closest('.group')

      container.addEventListener('mouseenter', () => {
        // Réduire le noir et blanc seulement, pas de zoom
        video.style.filter = 'grayscale(50%) contrast(1.4) brightness(1.05)'

        // Réduire légèrement l'autre vidéo
        const otherVideo = this.videoTargets[index === 0 ? 1 : 0]
        if (otherVideo) {
          otherVideo.style.filter = 'grayscale(100%) contrast(1.2) brightness(0.9)'
        }
      })

      container.addEventListener('mouseleave', () => {
        // Retour à l'état initial
        video.style.filter = 'grayscale(100%) contrast(1.3)'

        // Restaurer l'autre vidéo
        const otherVideo = this.videoTargets[index === 0 ? 1 : 0]
        if (otherVideo) {
          otherVideo.style.filter = 'grayscale(100%) contrast(1.3)'
        }
      })
    })
  }
}

